<template>
    <form novalidate>
        <div v-if="isMobile && modalView">

            <mdc-toolbar slot="toolbar"
                         class="navbar-expand-lg navbar-custom  navbar-dark bg-primary mb-0 mb-md-4">
                <div class="container">
                    <!--  toolbar markup here -->
                    <mdc-toolbar-row>
                        <mdc-toolbar-section shrink-to-fit>
                            <span @click="close()">
                                <mdc-icon icon="close"></mdc-icon>
                            </span>
                            <h3 class="title">DRO/DRI</h3>
                        </mdc-toolbar-section>
                        <mdc-toolbar-section align-end>
                            <button class="btn btn-link" @click.prevent="startSession">
                                {{'dro.start_session' | trans}}
                            </button>
                        </mdc-toolbar-section>
                    </mdc-toolbar-row>
                </div>
            </mdc-toolbar>
            <div class="mt-4">
                <div class="dro-settings d-flex flex-wrap">
                    <div class="form-group col-md-12 " :class="{'col-lg-5': !modalView}">
                        <h5 class="title">{{'dro.target_behaviour' | trans}}:</h5>
                        <mdc-radio v-model="form.aimTypeId" name="aimTypeId"
                                   :label="'dro.behaviour_absence' | trans" value="1"/>
                        <mdc-radio v-model="form.aimTypeId" name="aimTypeId"
                                   :label="'dro.behaviour_presence' | trans" value="2"/>
                    </div>
                    <!--<div class="form-group col-md-12" :class="{'col-lg-3': !modalView}">
                        <h5 class="title">{{'dro.behaviour_type' | trans}}:</h5>
                        <mdc-radio v-model="form.behaviourTypeId" name="behaviourTypeId"
                                   :label="'dro.behaviour_type_short' | trans" value="1"/>
                        <mdc-radio v-model="form.behaviourTypeId" name="behaviourTypeId"
                                   :label="'dro.behaviour_type_long' | trans"
                                   value="2"/>
                    </div>-->
                    <div class="form-group col-md-12" :class="{'col-lg-7': !modalView}">
                        <h5 class="title">{{'dro.interval_duration_units' | trans}}:</h5>
                        <mdc-radio v-model="form.intervalDurationUnitId"
                                   name="intervalDurationUnitId"
                                   :label="'dro.min' | trans" value="1"/>
                        <mdc-radio v-model="form.intervalDurationUnitId"
                                   name="intervalDurationUnitId"
                                   :label="'dro.sec' | trans"
                                   value="2"/>

                    </div>
                    <div class="form-group col-md-12" :class="{'col-lg-5': !modalView}">
                        <h5 v-if="form.intervalDurationUnitId == 1" class="title">
                            {{'dro.interval_time_range_minutes' |
                            trans}}:</h5>
                        <h5 v-else-if="form.intervalDurationUnitId == 2" class="title">
                            {{'dro.interval_time_range_seconds' |
                            trans}}:</h5>
                        <h5 v-else class="title">{{'dro.interval_time_range' | trans}}:</h5>
                        <mdc-textfield v-if="form.intervalDurationUnitId == 1"
                                       v-model="form.intervalDurationValue"
                                       name="intervalDurationValue"
                                       v-validate="'required|numeric|min_value:1|max_value:100'"
                                       :class="{'is-invalid': errors.has('intervalDurationValue')}"
                                       type="number"
                                       min="1"
                                       max="100"
                                       data-vv-validate-on="none"
                                       :data-vv-as="'validation.attributes.report.intervalDurationValue' | trans"/>
                        <mdc-textfield v-if="form.intervalDurationUnitId == 2"
                                       v-model="form.intervalDurationValue"
                                       name="intervalDurationValue"
                                       v-validate="'required|numeric|min_value:1|max_value:300'"
                                       :class="{'is-invalid': errors.has('intervalDurationValue')}"
                                       type="number"
                                       min="1"
                                       max="300"
                                       data-vv-validate-on="none"
                                       :data-vv-as="'validation.attributes.report.intervalDurationValue' | trans"/>
                        <span class="invalid-feedback"
                              v-if="errors.has('intervalDurationValue')">
                                                {{ errors.first('intervalDurationValue') }}
                                            </span>
                        <label v-if="form.intervalDurationUnitId == 1">{{'dro.min' |
                            trans}}</label>
                        <label v-else-if="form.intervalDurationUnitId == 2">{{'dro.sec' |
                            trans}}</label>
                    </div>
                    <div class="form-group  col-md-12" :class="{'col-lg-7': !modalView}">
                        <h5 class="title">{{'dro.behaviour_description' | trans}}:</h5>
                        <mdc-textfield v-model="form.behaviourDescription"
                                       name="behaviourDescription"
                                       v-validate="'max:255'"
                                       :class="{'is-invalid': errors.has('behaviourDescription')}"
                                       type="text"
                                       max="255"
                                       data-vv-validate-on="none"
                                       :data-vv-as="'validation.attributes.report.behaviourDescription' | trans"/>
                        <span class="invalid-feedback"
                              v-if="errors.has('behaviourDescription')">
                                                {{ errors.first('behaviourDescription') }}
                                            </span>
                    </div>

                </div>
            </div>

        </div>

        <div v-else>

            <div :class="{'rounded border shadow py-3': !modalView}">

            <div class="dro-settings d-flex flex-wrap">
                <div class="form-group col-md-12 " :class="{'col-lg-5': !modalView}">
                    <h5 class="title">{{'dro.target_behaviour' | trans}}:</h5>
                    <mdc-radio v-model="form.aimTypeId" name="aimTypeId"
                               :label="'dro.behaviour_absence' | trans" value="1"/>
                    <mdc-radio v-model="form.aimTypeId" name="aimTypeId"
                               :label="'dro.behaviour_presence' | trans" value="2"/>
                </div>
                <!--<div class="form-group col-md-12" :class="{'col-lg-3': !modalView}">
                    <h5 class="title">{{'dro.behaviour_type' | trans}}:</h5>
                    <mdc-radio v-model="form.behaviourTypeId" name="behaviourTypeId"
                               :label="'dro.behaviour_type_short' | trans" value="1"/>
                    <mdc-radio v-model="form.behaviourTypeId" name="behaviourTypeId"
                               :label="'dro.behaviour_type_long' | trans"
                               value="2"/>
                </div>-->
                <div class="form-group col-md-12" :class="{'col-lg-7': !modalView}">
                    <h5 class="title">{{'dro.interval_duration_units' | trans}}:</h5>
                    <mdc-radio v-model="form.intervalDurationUnitId"
                               name="intervalDurationUnitId"
                               :label="'dro.min' | trans" value="1"/>
                    <mdc-radio v-model="form.intervalDurationUnitId"
                               name="intervalDurationUnitId"
                               :label="'dro.sec' | trans"
                               value="2"/>

                </div>
                <div class="form-group col-md-12" :class="{'col-lg-5': !modalView}">
                    <h5 v-if="form.intervalDurationUnitId == 1" class="title">
                        {{'dro.interval_time_range_minutes' |
                        trans}}:</h5>
                    <h5 v-else-if="form.intervalDurationUnitId == 2" class="title">
                        {{'dro.interval_time_range_seconds' |
                        trans}}:</h5>
                    <h5 v-else class="title">{{'dro.interval_time_range' | trans}}:</h5>
                    <mdc-textfield v-if="form.intervalDurationUnitId == 1"
                                   v-model="form.intervalDurationValue"
                                   name="intervalDurationValue"
                                   v-validate="'required|numeric|min_value:1|max_value:100'"
                                   :class="{'is-invalid': errors.has('intervalDurationValue')}"
                                   type="number"
                                   min="1"
                                   max="100"
                                   data-vv-validate-on="none"
                                   :data-vv-as="'validation.attributes.report.intervalDurationValue' | trans"/>
                    <mdc-textfield v-if="form.intervalDurationUnitId == 2"
                                   v-model="form.intervalDurationValue"
                                   name="intervalDurationValue"
                                   v-validate="'required|numeric|min_value:1|max_value:300'"
                                   :class="{'is-invalid': errors.has('intervalDurationValue')}"
                                   type="number"
                                   min="1"
                                   max="300"
                                   data-vv-validate-on="none"
                                   :data-vv-as="'validation.attributes.report.intervalDurationValue' | trans"/>
                    <span class="invalid-feedback"
                          v-if="errors.has('intervalDurationValue')">
                                                {{ errors.first('intervalDurationValue') }}
                                            </span>
                    <label v-if="form.intervalDurationUnitId == 1">{{'dro.min' |
                        trans}}</label>
                    <label v-else-if="form.intervalDurationUnitId == 2">{{'dro.sec' |
                        trans}}</label>
                </div>
                <div class="form-group  col-md-12" :class="{'col-lg-7': !modalView}">
                    <h5 class="title">{{'dro.behaviour_description' | trans}}:</h5>
                    <mdc-textfield v-model="form.behaviourDescription"
                                   name="behaviourDescription"
                                   v-validate="'max:255'"
                                   :class="{'is-invalid': errors.has('behaviourDescription')}"
                                   type="text"
                                   max="255"
                                   data-vv-validate-on="none"
                                   :data-vv-as="'validation.attributes.report.behaviourDescription' | trans"/>
                    <span class="invalid-feedback"
                          v-if="errors.has('behaviourDescription')">
                                                {{ errors.first('behaviourDescription') }}
                                            </span>
                </div>

            </div>
            </div>


            <footer class="mdc-dialog__footer mdc-dialog__footer--visible" v-if="modalView">
                <button type="button"
                        class="mdc-button mdc-button--raised button-success text-uppercase col-md-12"
                        @click.prevent="startSession()"> {{'dro.start_session' | trans}}
                </button>
            </footer>

            <div class="dro-settings form group-row"  v-if="!modalView">
                <div class="text-center">
                    <mdc-button type="submit" class="button-success text-uppercase col-sm-6 mt-4"
                                @click.prevent="startSession()" :disabled="disabled">{{'dro.start_session' | trans}}
                    </mdc-button>
                </div>
            </div>

        </div>
    </form>
</template>

<script>
  import {mapGetters} from 'vuex';

  export default {
    props: {
      'modalView': {
        type: Boolean,
        default() {
          return false;
        },
      },
      'settings': {
        type: Object,
        default() {
          return {};
        },
      },
    },
    data() {
      return {
        disabled: false,
        form: {
          aimTypeId: '1',
          behaviourTypeId: '1',
          intervalDurationValue: null,
          intervalDurationUnitId: '1',
          behaviourDescription: '',
        },
      };
    },
    computed: {
      ...mapGetters('mobile', [
        'isMobile',
      ]),
    },
    created() {
      for (let [key, value] of Object.entries(this.settings)) {
        if (value && this.form.hasOwnProperty(key)) {
          this.form[key] = value;
        }
      }
    },
    methods: {
      close(){
        this.$emit('close');
      },
      async startSession() {
        this.disabled = true;
        let result = await this.$validator.validateAll();
        if (!result) {
          this.disabled = false;
          return;
        }
        this.$emit('session-settings-set', this.form);
        this.disabled = false;
        if (this.modalView){
          this.close();
        }
      },
    },
  };
</script>


// WEBPACK FOOTER //
// src/modules/dro/components/SettingsForm.vue